/**
 * Préselection / sync tailles cross-sells (hub → accessoires).
 * Ex. botte 43 → semelle 43 ; botte 43 → chaussette M.
 */
(function () {
  const LETTER_FROM_EU = [
    { letter: "xs", eus: ["36", "37", "38"] },
    { letter: "s", eus: ["38", "39", "40", "40.5", "41"] },
    { letter: "m", eus: ["41", "42", "43", "44", "44.5"] },
    { letter: "l", eus: ["44.5", "45", "45.5", "46", "47"] },
    { letter: "xl", eus: ["47", "48", "49", "49.5", "50"] },
    { letter: "xxl", eus: ["49", "50", "51", "52"] },
  ];

  function fold(s) {
    return String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/,/g, ".")
      .replace(/\s+/g, " ")
      .trim();
  }

  function parseSizeKey(raw) {
    const f = fold(raw)
      .replace(/taille|size|pointure|eu|us|uk/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    if (!f || f === "default title" || f === "default") return null;

    const letter = f.match(/\b(xxxxl|xxxl|xxl|xl|xs|s|m|l)\b/);
    if (letter) return { kind: "letter", key: letter[1] };

    if (/\b(youth|enfant|kids?|jr|junior)\b/.test(f)) {
      return { kind: "letter", key: "youth" };
    }

    const eu = f.match(/\b((?:3[6-9]|4[0-9]|5[0-2])(?:\.5)?)\b/);
    if (eu) return { kind: "eu", key: eu[1] };

    const mm = f.match(/\b(\d{2})\s*mm\b/);
    if (mm) return { kind: "mm", key: mm[1] + "mm" };

    return null;
  }

  function euToLetters(euKey) {
    const out = [];
    for (const row of LETTER_FROM_EU) {
      if (row.eus.includes(euKey)) out.push(row.letter);
    }
    return out;
  }

  function scoreOption(hubSize, optionSize, hubType, accType) {
    if (!hubSize || !optionSize) return -1;
    if (hubSize.key === optionSize.key && hubSize.kind === optionSize.kind) return 100;
    if (hubSize.kind === "eu" && optionSize.kind === "eu" && hubSize.key === optionSize.key) {
      return 100;
    }
    if (hubSize.kind === "letter" && optionSize.kind === "letter" && hubSize.key === optionSize.key) {
      return 100;
    }
    // botte EU → chaussette / gant lettre
    const accBlob = fold(accType || "");
    const hubBlob = fold(hubType || "");
    const accIsLetterWear = /chaussette|gant|maillot|pantalon|short|veste/.test(accBlob);
    const hubIsBoot = /botte/.test(hubBlob);
    if (hubIsBoot && hubSize.kind === "eu" && optionSize.kind === "letter" && accIsLetterWear) {
      const letters = euToLetters(hubSize.key);
      if (letters.includes(optionSize.key)) return 80;
    }
    // tenue lettre → gant lettre already exact
    // soft: option title contains hub key
    return -1;
  }

  function readHubSizeFromPage() {
    // Prefer main product form selected variant options
    const form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector("product-form form") ||
      document.querySelector(".product-form form");
    if (form) {
      const idInput = form.querySelector('[name="id"]');
      if (idInput) {
        // variant-selects / picker: try selected options text
        const checked = form.querySelectorAll(
          "variant-selects input:checked, variant-radios input:checked, fieldset input:checked"
        );
        for (const input of checked) {
          const label =
            input.getAttribute("value") ||
            (input.nextElementSibling && input.nextElementSibling.textContent) ||
            "";
          const name =
            (input.closest("fieldset") &&
              input.closest("fieldset").querySelector("legend") &&
              input.closest("fieldset").querySelector("legend").textContent) ||
            input.name ||
            "";
          if (/taille|size|pointure/i.test(name) || parseSizeKey(label)) {
            const parsed = parseSizeKey(label);
            if (parsed) return parsed;
          }
        }
        // selects
        const selects = form.querySelectorAll("select");
        for (const sel of selects) {
          const label =
            (sel.previousElementSibling && sel.previousElementSibling.textContent) ||
            sel.getAttribute("name") ||
            "";
          if (/taille|size|pointure|option/i.test(label) || true) {
            const parsed = parseSizeKey(sel.options[sel.selectedIndex]?.text || sel.value);
            if (parsed && /taille|size|pointure/i.test(label)) return parsed;
          }
        }
      }
    }

    // Fallback: data attribute on cross-sells root
    const root = document.querySelector("lumin-cross-sells[data-mm-hub-size]");
    if (root && root.dataset.mmHubSize) {
      return parseSizeKey(root.dataset.mmHubSize);
    }
    return null;
  }

  function readMainVariantId() {
    const form =
      document.querySelector('product-info form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector("product-form form") ||
      document.querySelector(".product-form form");
    if (!form) return null;
    const idInput = form.querySelector('[name="id"]');
    return idInput && idInput.value ? String(idInput.value) : null;
  }

  function syncCurrentItem(item, variantId) {
    if (!item || !variantId) return;
    const checkbox = item.querySelector('input[type="checkbox"]');
    const select = item.querySelector('select[name="variant-id"]');
    const hidden = item.querySelector('input[type="hidden"][name="variant-id"]');

    if (select) {
      const opt = Array.from(select.options).find((o) => String(o.value) === variantId && !o.disabled);
      if (opt) {
        select.value = opt.value;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    } else if (hidden) {
      hidden.value = variantId;
    }

    if (checkbox && !checkbox.disabled) {
      checkbox.checked = true;
      item.setAttribute("data-is-selected", "true");
      checkbox.value = variantId;
    }
  }

  function syncCrossSells(hubSize) {
    const roots = document.querySelectorAll("lumin-cross-sells");
    const mainVariantId = readMainVariantId();
    roots.forEach((root) => {
      const hubType = root.dataset.mmHubType || "";
      if (!hubSize && root.dataset.mmHubSize) {
        hubSize = parseSizeKey(root.dataset.mmHubSize);
      }
      root.querySelectorAll("[data-cross-sells-list-item]").forEach((item) => {
        // Produit courant : suit la variante du PDP, toujours coché
        if (item.dataset.mmIsCurrent === "true") {
          syncCurrentItem(item, mainVariantId);
          return;
        }

        const select = item.querySelector('select[name="variant-id"]');
        const checkbox = item.querySelector('input[type="checkbox"]');
        if (!select || !checkbox) return;

        const accType = item.dataset.mmProductType || "";
        let best = null;
        let bestScore = -1;
        for (let i = 0; i < select.options.length; i++) {
          const opt = select.options[i];
          if (opt.disabled) continue;
          const optSize = parseSizeKey(opt.dataset.sizeKey || opt.textContent || "");
          const score = scoreOption(hubSize, optSize, hubType, accType);
          if (score > bestScore) {
            bestScore = score;
            best = opt;
          }
        }

        if (best && bestScore >= 80) {
          select.value = best.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
        // Toujours coché d'office (sauf sold out)
        if (!checkbox.disabled) {
          checkbox.checked = true;
          item.setAttribute("data-is-selected", "true");
        }
      });
      if (typeof root.updateTotalPrice === "function") root.updateTotalPrice();
    });
  }

  function onHubVariantMaybeChanged() {
    const hubSize = readHubSizeFromPage();
    const roots = document.querySelectorAll("lumin-cross-sells");
    roots.forEach((root) => {
      if (hubSize) root.dataset.mmHubSize = hubSize.key;
    });
    syncCrossSells(hubSize);
  }

  function bind() {
    // Initial
    onHubVariantMaybeChanged();

    document.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;
      if (
        t.matches(
          'form [name="id"], form [name="options[Taille]"], form [name="options[Size]"], form [name="options[Pointure]"], variant-selects input, variant-radios input, fieldset input, .product-form select, variant-selects select'
        ) ||
        (t.closest && t.closest("variant-selects, variant-radios, product-info, .product-form"))
      ) {
        // ignore changes inside cross-sells themselves
        if (t.closest && t.closest("lumin-cross-sells")) return;
        setTimeout(onHubVariantMaybeChanged, 30);
      }
    });

    document.addEventListener("variant:change", () => {
      setTimeout(onHubVariantMaybeChanged, 30);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
